export const common = {
  defaults: null,
  set DEFAULTS(defaults) {
    this.defaults = defaults
  },
  get DEFAULTS() {
    return this.defaults
  }
}
